// highlights the anchor link to the section that is at the op of the viewport
export default () => {
  const sections = document.querySelectorAll('[data-highlight-active-section]');

  if (sections.length) {
    // const link = document.getElementById(link.hash.substring(1));

    const highlightActive = () => {
      const activePoint = window.innerHeight * 0.2;
      sections.forEach((el) => {
        if (el.getBoundingClientRect().top < activePoint
          && el.getBoundingClientRect().bottom > activePoint
        ) {
          const link = document.querySelector(`a[href="#${el.id}"`);
          const className = el.dataset.highlightActiveSection;

          document.querySelectorAll(`.${className}`).forEach((el) => {
            el.classList.remove(className);
          });
          link.classList.add(className);
        }
      });
    };

    window.addEventListener('scroll', highlightActive);
  }
};
